module.exports = __webpack_public_path__ + "video/2800_CT_2022_Intro.3b95c2ab.vtt";